/* fm-card-carousel — cycles all product-info shots on a card.
   Auto-advances while the card is hovered; dots are clickable any time. */
(function () {
  function initOne(cc) {
    if (cc.__ccInit) return;
    cc.__ccInit = true;

    var imgs = cc.querySelectorAll('.fm-cc__img');
    var dots = cc.querySelectorAll('.fm-cc__dot');
    if (imgs.length < 2) return;

    var i = 0;
    var timer = null;

    function show(n) {
      i = (n + imgs.length) % imgs.length;
      for (var k = 0; k < imgs.length; k++) {
        imgs[k].classList.toggle('is-active', k === i);
      }
      for (var d = 0; d < dots.length; d++) {
        dots[d].classList.toggle('is-active', d === i);
      }
    }

    function start() {
      stop();
      timer = setInterval(function () { show(i + 1); }, 900);
    }
    function stop() {
      if (timer) { clearInterval(timer); timer = null; }
    }

    var host = cc.closest('.fm-cp-card, .fm-fp-card, .fm-fp-showcase') || cc.parentElement;
    host.addEventListener('mouseenter', start);
    host.addEventListener('mouseleave', function () { stop(); show(0); });

    dots.forEach(function (dot) {
      dot.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        stop();
        show(parseInt(dot.getAttribute('data-fm-cc-dot'), 10) || 0);
      });
    });

    var prev = cc.querySelector('[data-fm-cc-prev]');
    var next = cc.querySelector('[data-fm-cc-next]');
    function step(delta) {
      return function (e) {
        e.preventDefault();
        e.stopPropagation();
        stop();
        show(i + delta);
      };
    }
    if (prev) prev.addEventListener('click', step(-1));
    if (next) next.addEventListener('click', step(1));
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-fm-cc]').forEach(initOne);
  }

  if (document.readyState !== 'loading') {
    initAll();
  } else {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  }

  // Re-init when a section is re-rendered in the theme editor.
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
